function r(f) {
  /in/.test(document.readyState) ? setTimeout(() => r(f), 9) : f();
}

r(function () {
  const updateCaption = (selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.textContent = "Usually ready in 2-4 Weeks for bulky items";
    });
  };

  updateCaption(".pickup-availability-info .caption");
  updateCaption(".pickup-availability-list .caption-large");
  updateCaption("._1x52f9si");

  /* const elementClose = document.getElementById("custom-close");
  const element = document.getElementById("che-hamburger-menu");
  const overlay = document.getElementById("che-menu-overlay");
  const body = document.body;

  if (element && overlay) {
    element.onclick = (e) => {
      e.preventDefault();
      const isActive = element.classList.toggle("active");
      overlay.classList.toggle("active", isActive);
      overlay.classList.toggle("remove", !isActive);
      body.classList.toggle("noscroll", isActive);
    };
  } */
  const elementClose = document.getElementById("custom-close");
const element = document.getElementById("che-hamburger-menu");
const overlay = document.getElementById("che-menu-overlay");
const body = document.body;

if (element && overlay && elementClose) {
  element.onclick = (e) => {
    e.preventDefault();
    const isActive = element.classList.toggle("active");
    overlay.classList.toggle("active", isActive);
    overlay.classList.toggle("remove", !isActive);
    body.classList.toggle("noscroll", isActive);
  };

  elementClose.onclick = (e) => {
    e.preventDefault();
    element.classList.remove("active");
    overlay.classList.remove("active");
    overlay.classList.add("remove");
    body.classList.remove("noscroll");
  };
}

  const elementsToShow = [
    "apps-che-category-slider-wrapper",
    "che-product-slider-fridges",
    "che-product-slider-outdoor-wrapper",
    "che-home-slider-wrapper",
    "che-mouse-over-slider-container",
    "che-simple-image-banner",
    "gazebo-product-slider-wrapper",
  ];

  elementsToShow.forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.display = "block";
  });

  const collection = document.getElementsByClassName(
    "che-mouse-over-src-slider"
  );
  if (collection.length > 0) {
    const dataSrc = collection[0].getAttribute("data-src");
    const mouseOverMainElement = document.getElementById(
      "che-mouse-over-slider"
    );
    if (mouseOverMainElement && dataSrc) {
      mouseOverMainElement.style.backgroundImage = `url('${dataSrc}')`;
      mouseOverMainElement.style.backgroundPosition = "center";
      mouseOverMainElement.style.backgroundRepeat = "no-repeat";
      mouseOverMainElement.style.backgroundSize = "cover";
    }
  }

  const initSlider = (container, itemsConfig) => {
    const sliderContainer = document.querySelector(container);
    if (!sliderContainer) {
      return null;
    }

    const slider = tns({
      container,
      items: itemsConfig.default,
      autoplay: itemsConfig.autoplay || false,
      controlsPosition: "right",
      autoplayButtonOutput: false,
      arrowKeys: true,
      controls: false,
      nav: itemsConfig.nav || false,
      autoplayButton: false,
      mouseDrag: true,
      responsive: itemsConfig.responsive,
    });

    const addAnimatedClass = () => {
      const slideItems = document.querySelectorAll(container + " .tns-item");
      slideItems.forEach((item) => {
        item.classList.add("animate__animated");
      });
    };
    addAnimatedClass();

    if (container === ".che-home-slider-container") {
      slider.events.on("indexChanged", function (info) {
        const slideItems = document.querySelectorAll(container + " .tns-item");
        slideItems.forEach((item, index) => {
          if (index === info.index) {
            item.classList.add("animate__fadeIn");
            item.classList.remove("animate__fadeOut");
          } else {
            item.classList.add("animate__fadeOut");
            item.classList.remove("animate__fadeIn");
          }
        });
      });
    }

    return slider;
  };

  const slidersConfig = [
    {
      container: ".che-mouse-over-slider",
      items: 4,
      autoplay: true,
      responsive: {
        200: { items: 1 },
        640: { items: 2 },
        900: { items: 4 },
        1200: { items: 4 },
      },
    },
    {
      container: ".apps-che-category-slider",
      items: 7,
      responsive: {
        100: { items: 3 },
        640: { items: 3 },
        700: { items: 4 },
        900: { items: 5 },
        1200: { items: 7 },
      },
    },
    {
      container: ".che-product-slider-fridge",
      items: 7,
      responsive: {
        300: { items: 2 },
        700: { items: 4 },
        900: { items: 5 },
        1200: { items: 5 },
      },
    },
    {
      container: ".che-home-slider-container",
      items: 1,
      autoplay: true,
      autoHeight: true,
      mouseDrag: true,
      nav: true,
      animateIn: "animate__fadeIn",
      animateOut: "animate__fadeOut",
    },
    {
      container: ".che-simple-slider-container",
      items: 1,
      autoplay: true,
      autoHeight: true,
      mouseDrag: true,
    },
    {
      container: ".che-product-slider-outdoor",
      items: 7,
      responsive: {
        300: { items: 2 },
        700: { items: 4 },
        900: { items: 4 },
        1200: { items: 4 },
        1300: { items: 5 },
      },
    },
    {
      container: ".gazebo-product-slider-outdoor",
      items: 7,
      responsive: {
        300: { items: 2 },
        700: { items: 4 },
        900: { items: 4 },
        1200: { items: 4 },
        1300: { items: 5 },
      },
    },
  ];

  const sliders = slidersConfig.map((config) =>
    initSlider(config.container, config)
  );
});

$(window).on("load", function () {
  $(".custom-slick-slider").each(function () {
    var sliderEl = $(this);

    // Check if the slider element exists
    if (sliderEl.length) {
      try {
        sliderEl
          .slick({
            autoplay: false,
            autoplaySpeed: 3000,
            /* centerMode: true, */
            centerPadding: "60px",
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  /* centerMode: true, */
                  centerPadding: "40px",
                  slidesToShow: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  arrows: false,
                  /* centerMode: true, */
                  centerPadding: "40px",
                  slidesToShow: 1,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  arrows: false,
                  /* centerMode: true, */
                  centerPadding: "40px",
                  slidesToShow: 1,
                },
              },
            ],
          })
          .show(); // Show the slider after initializing

        // Remove the loading message if it exists
        sliderEl.prev(".loading-message").remove();
      } catch (error) {
        console.error("Error initializing Slick slider:", error);
      }
    } else {
      console.warn("Slider element not found:", sliderEl);
    }
  });
});
